export default "__VITE_PUBLIC_ASSET__a65f9fc7__"